import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("title", function () {
        return [
          _c(
            "div",
            {
              staticClass:
                "text-body-2 text-secondary--text d-flex align-center mb-1",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t("Минимальная учёная степень", _setup.options)
                  ) +
                  "\n\n      "
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1",
                  attrs: { icon: "", text: "", small: "", color: "text-info" },
                  on: { click: _setup.openDialog },
                },
                [
                  _c(VIcon, { attrs: { size: "20" } }, [
                    _vm._v("\n          ui-icon-circle-info\n        "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(VOverlay, {
                attrs: { value: _setup.isDialogOpened },
                on: { click: _setup.closeDialog },
              }),
              _vm._v(" "),
              _c(
                _setup.DialogBottomSheet,
                {
                  attrs: {
                    "is-visible": _setup.isDialogOpened,
                    width: _setup.isMobile ? undefined : 375,
                    "hide-overlay": "",
                    attach: ".vue-the-doctors-filters .v-application",
                    "content-class": "rounded-0",
                  },
                  on: {
                    "dialog-bottom-sheet:change-visible": _setup.closeDialog,
                  },
                },
                [
                  _c(
                    VCard,
                    { staticClass: "px-2 py-4", attrs: { tile: "" } },
                    [
                      _c("div", { staticClass: "pa-2 mb-2" }, [
                        _c("div", { staticClass: "text-h6 mb-2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.academicDegree.title,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-body-2 mb-4" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.academicDegree.description,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-subtitle-2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.candidateOfScience.title,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-body-2 mb-4" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.candidateOfScience
                                    .description,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-subtitle-2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.doctorOfScience.title,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-body-2 mb-4" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.doctorOfScience
                                    .description,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-subtitle-2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.professor.title,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-body-2" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _setup.t(
                                  _setup.DESCRIPTION.professor.description,
                                  _setup.options
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          attrs: { color: "primary", block: "", depressed: "" },
                          on: { click: _setup.closeDialog },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_setup.t("Понятно", _setup.options)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      }),
      _vm._v(" "),
      _c(
        VChipGroup,
        {
          attrs: {
            value: _setup.doctorFiltersState.science,
            column: "",
            "active-class": "primary",
          },
          on: { change: _setup.handleChangeChip },
        },
        _vm._l(_setup.scienceChips, function (chip, i) {
          return _c(
            VChip,
            {
              key: i,
              attrs: {
                value: chip.value,
                color:
                  chip.value === _setup.doctorFiltersState.science
                    ? "primary"
                    : "bg-primary",
                "text-color":
                  chip.value === _setup.doctorFiltersState.science
                    ? "bg-gray-0"
                    : "primary",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t(chip.name, _setup.options)) +
                  "\n    "
              ),
            ]
          )
        }),
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }